import angular from 'angular';

import CollaboratorInviteModalComponent from './collaborator-invite-modal.cmpt';

export default angular
    .module('application.component.modals.component.collaborator-invite-modal', [])
    .component(CollaboratorInviteModalComponent.selector, CollaboratorInviteModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/collaborator-invite-modal/index.js